import { Injectable, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConfig } from "src/app/models/app-config/app-configDto";
import { environment } from "src/environments/environment";
import { forkJoin } from "rxjs";
import { map, tap } from "rxjs/operators";

interface Config { 
  useConfigHostname: boolean;
  hostname: string;
  port: string;
  fallbackHost: string;
  fallbackPort: string;
  basePath: string 
};

@Injectable({
  providedIn: "root",
})
export class AppSessionService implements OnInit {
  // private _logo: any;
  // private _topNavColor: any;
  // private _sideNavColor: any;
  // private _backgroundColor: any;
  // private _appName: string;
  // private _isWhiteLabelInstance: boolean;
  // private _config: any;

  private _configuration: AppConfig;

  private baseApiUrl = "";
  private fallbackApiUrl = "";
  private baseHomePath = "";

  private BASE_URL = this.baseUrl + "/api/v1";

  private usefallback = false;

  // Configure Angular `environment.ts` file path

  constructor(private http: HttpClient) {
    // this._logo = "url('http://www.galpenergia.com/Style%20Library/Images/twitter_share.jpg')";
    // this._topNavColor = 'blue';

    const targetPath = "./src/environments/environment.ts";
    // const writeFile = require('write-file');

    // this.getConfigs();
    // this.http.get('assets/properties.txt', { responseType: 'text' })
    //   .subscribe(data => {
    //     if (data && data.length > 0) {

    //       const configProperties = JSON.parse(data);
    //       localStorage.setItem('apiGatewayUrl', configProperties?.apiGatewayUrl);
    //       this.appSession.baseUrl = configProperties?.apiGatewayUrl;

    // `environment.ts` file structure
    // const envConfigFile = `
    //           import { version } from '../../package.json'
    //             export const environment = {
    //             apiGatewayUrl: '${configProperties?.apiGatewayUrl}',
    //             version: '${configProperties?.version}',
    //           };
    //           `;
    // angularFs.writeFile(targetPath, envConfigFile, (err) => {
    //   if (err) {
    //     throw console.error(err);
    //   } else {
    //     console.log(`Angular environment.ts file generated correctly at ${targetPath} \n`);
    //   }
    // });
    // }
    // });
  }

  // get logo() {
  //   return this._logo;
  // }

  // get topNavColor() {
  //   return this._topNavColor;
  // }

  get appName(): string {
    if (this._configuration) {
      return this._configuration.appName;
    }
  }

  // async getConfigs() {
  //   await this.http.get('assets/properties.txt', { responseType: 'text' })
  //     .subscribe(data => {
  //       if (data && data.length > 0) {

  //         const configProperties = JSON.parse(data);
  //         localStorage.setItem('apiGatewayUrl', configProperties?.apiGatewayUrl);
  //         this.appSession.baseUrl = configProperties?.apiGatewayUrl;
  //       }
  //     });
  // }

  ngOnInit() {
    // this._logo = "url('http://www.galpenergia.com/Style%20Library/Images/twitter_share.jpg')";
    // this._topNavColor = 'blue';

    // this.getConfig().subscribe((res) => {

    //   console.dir(res);
    // });

    this._configuration = this.getConfig();
    // this.getUserProfile();

    this.applyConfig();
  }

  getConfig() {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const url = `${this.baseUrl + "/api/v1"}/appConfig`;

    return {
      id: 1,
      logo: "assets/images/galplogo.png",
      appName: "Alarmistica",
      topNavColor: "#222",
      sideNavColor: "#222",
      backgroundColor: "#222",
      isWhiteLabelInstance: true,
      // firstColor: '#333',
    } as AppConfig;

    // return this.http.get(url, { headers }).pipe(
    //   tap(res => {
    //     return res;
    //   }),
    //   catchError(error => {
    //     return of(MessagesActionTypes.setMessage(
    //       {
    //         appMessage:
    //           { message: error ?
    // (error.error ? error.message : error) : error, owner: 'App-Session', severity: 'error', timestamp: new Date().getTime() }
    //       }
    //     ))
    //   })
    // );
  }

  applyConfig() {
    // let opt2: string = "assets/images/galplogo.png";
    // let fullpath: string = "http://www.galpenergia.com/Style%20Library/Images/twitter_share.jpg";
    // let url = "url('" + fullpath + "')";
    if (this._configuration) {
      let url = "url('" + this._configuration.logo + "')";
      this._configuration.logo = url; //"url('"+ this._configuration.logo + "')";

      Object.keys(this._configuration).forEach((k) => {
        if (typeof this._configuration[k] === "string") {
          document.documentElement.style.setProperty(
            "--" + k,
            this._configuration[k]
          );
        }
      });
    }
    // document.documentElement.style.setProperty('--url', this.logo);
    // document.documentElement.style.setProperty('--first-color', this.topNavColor);

    // let prefix: string = "/assets/images/";
    // let img = "grupo-petrotec-logo5.png";
    // let img: string = "galplogo.png";
    // let fullpath : string = "http://www.galpenergia.com/Style%20Library/Images/twitter_share.jpg";
    // let url = "url('"+ fullpath + "')";
    // let url = "url('"+ fullpath + "')";
    // console.dir(url);
    // document.documentElement.style.setProperty('--url', url);
    // document.documentElement.style.setProperty('--first-color', 'pink');
  }

  loadConfig() {
    return forkJoin(this.getConfigKeys());
  }

  get baseUrl(): string {
    return this.usefallback ? this.fallbackUrl : this.baseApiUrl;
  }

  get fallbackUrl(): string {
    return this.fallbackApiUrl;
  }

  get basePath(): string {
    return this.baseHomePath;
  }

  set useFallback(use: boolean) {
    this.usefallback = use;
  }

  getConfigKeys() {
    return this.http.get<Config>("/assets/config.json").pipe(
      map((config) => {
        this.baseApiUrl = 
          config.useConfigHostname && config.hostname && config.port 
            ? `${config.hostname}:${config.port}` 
            : config.port 
              ? `${window.location.protocol}//${window.location.hostname}:${config.port}`
              : null;
        this.fallbackApiUrl = 
          config.useConfigHostname && config.fallbackHost && config.fallbackPort 
            ? `${config.fallbackHost}:${config.fallbackPort}` 
            : config.fallbackPort
              ? `${window.location.protocol}//${window.location.hostname}:${config.fallbackPort}`
              : null;
        this.baseHomePath = config.basePath;
      })
    );
  }  
}
